import type { GeoPoint } from '@api/types'

// "Cómo llegar": abre la ruta hasta el punto en Google Maps (app o web, la que tenga el móvil).
// Solo se envía el destino, y solo si el caminante pulsa el enlace. null si las coordenadas no
// son válidas.
export const directionsUrl = ({ latitude, longitude }: GeoPoint): string | null => {
	const valid =
		Number.isFinite(latitude) &&
		Number.isFinite(longitude) &&
		Math.abs(latitude) <= 90 &&
		Math.abs(longitude) <= 180
	return valid ? `https://www.google.com/maps/dir/?api=1&destination=${latitude},${longitude}` : null
}
